module.exports = __webpack_public_path__ + "static/media/posture-sante.871d0fe6.jpg";